import { Injectable } from '@angular/core';
import { Headers, RequestOptions, Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { SessionStorageService } from '../core/sessionstorage.service';

import { environment } from '../../environments/environment';

import * as Services from './index.service';

//@Injectable()
export class HttpHeader {
    
    constructor() { }

    private storageService: SessionStorageService = new SessionStorageService();

    public Http_Header_Request_OptionsTest(): RequestOptions {
        let header = new Headers(
            {
                'Content-Type': 'application/json',
                'DBName': window.location.hostname,
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Token': this.storageService.getUserToken(),
                'PhoenixKey': (this.storageService.getUserID()) ? null : this.storageService.getUseAccessKey()
            }
        );

        return new RequestOptions({ headers: header });
    }
}

//import { Headers, RequestOptions } from '@angular/http';

export const header = new Headers(
    {
        'Content-Type': 'application/json',
        'DBName': window.location.hostname,
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
    }

);
export const Http_Header_Request_Options = new RequestOptions({ headers: header });


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/httpheader.ts